<template lang="pug">
SideOverlaySlot(
  :isOpen="isOpen",
  title="PATIENT NAVIGATION"
  @closeOverlay="closeOverlay"
)
  template(#contentTop)
    section.patient-section
      .patient-section__top
        p.bold.patient-name {{ showReferral?.patient?.first }} {{ showReferral?.patient?.last }}
        p.small-text
          span Date/Time: {{ getDateFromUnixFormatted(showReferral?.scheduledAt) }} {{ showReferral?.timeOfAppointment || '' }}
        p.small-text
          span Referral Type: {{ getReferralType(showReferral) }}
        p.bold
          span Provider/Location: {{ showReferral?.providerLocation || 'N/A' }}

    .follow-up-warning(v-if="isSecondFollowUpDue")
      .follow-up-warning__content
        span Final Follow Up Due!
    .follow-up-warning(v-else-if="isFirstFollowUpDue")
      .follow-up-warning__content
        span 1st Follow Up Due!
  template(#scrollbox)
    .overlay-pairs.history-section(v-if="notification")
      .item
        .new {{ notification.status }}
        .date-user
          .date-user__line
          .date-user__txt {{ getNoteTitle(notification) }}
        .pairs.columns
          .pair.column.is-half
            .pair-label Type
            .pair-txt <strong>{{ notification.type}}</strong>
          .pair.column.is-half(v-if="notification.lastViewedBy")
            .pair-label Last Viewed By
            .pair-txt <strong>{{ getUserFormatted(notification.lastViewedBy) }}</strong>
        .pairs.columns
          .pair.column
            .pair-label Message
            .pair-txt
              p {{ notification.content }}
        div(v-if="notificationCanBeMarked(currentNotification)")
          BaseBtn.md.green.mark-done(
            href="#", 
            @click.prevent="openMarkAsRead(currentNotification.id)"
            v-if=("!currentNotification.markOpen")
          ) MARK AS READ
          div.mark-done-confirmations(v-else)
            BaseBtn.md.blue.margin-right(@click.prevent="markNotificationAsRead(currentNotification.id)") Yes, Mark as Read
            BaseBtn.md.redFill(@click.prevent="resetMarkedAsRead(currentNotification.id)") NO, CANCEL

  template(#footer)
    .flex.flex--space-between
      BaseBtn.x-lg.blue-outline(@click="viewReferral") VIEW REFERRAL
</template>

<script>
import { defineComponent } from "vue";

import SideOverlaySlot from "@/components/overlays/SideOverlaySlot";
import listPagesMixin from "@/mixins/listPagesMixin";

import { putNotification } from "@/api/notifications.ts";

import {
  getUserFormatted,
  getNoteTitle,
  getDateFromUnixFormatted,
} from "@/helpers";

import { mapGetters } from "vuex";

import { apiStatus } from "@/api";
const { IDLE, PENDING, SUCCESS, ERROR } = apiStatus;

export default defineComponent({
  components: {
    SideOverlaySlot,
  },
  mixins: [listPagesMixin],

  emits: ["closeOverlay", "fetchNotifications", "viewReferral"],

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    notification: {
      required: true,
      type: Object,
    },
    showReferral: {
      required: false,
      type: Object,
    },
  },

  data() {
    return {
      getUserFormatted,
      getNoteTitle,
      getDateFromUnixFormatted,
      markNotificationAsReadStatus: IDLE,
      PENDING,
      localNotification: null,
    };
  },
  computed: {
    ...mapGetters(["getUserId", "getUserFullName", "getUserRoleContext"]),
    currentNotification() {
      return this.localNotification || this.notification;
    },
    isFirstFollowUpDue() {
      return this.showReferral?.isFirstFollowUpDue || false;
    },
    isSecondFollowUpDue() {
      return this.showReferral?.isSecondFollowUpDue || false;
    },
  },
  methods: {
    getReferralType(referral) {
      // This method should match the one from ReferralRecordOverlay
      return referral?.referralType || "N/A";
    },

    viewReferral() {
      this.$emit("viewReferral", this.notification);
    },

    notificationCanBeMarked(notification) {
      return notification.status === "New";
    },

    async markNotificationAsRead(notificationID) {
      this.markNotificationAsReadStatus = PENDING;
      try {
        const res = await putNotification(notificationID, {
          completedBy: this.getUserId,
          lastViewedBy: this.getUserId,
          status: "Completed",
        });
        this.markNotificationAsReadStatus = SUCCESS;
        this.$emit("fetchNotifications");
        this.$emit("closeOverlay");
        this.$store.dispatch("fetchNotificationCount");
      } catch (err) {
        this.markNotificationAsReadStatus = ERROR;
        console.error("markNotificationAsRead error:", err);
      }
    },

    closeOverlay() {
      this.$emit("closeOverlay");
    },

    openMarkAsRead(notificationId) {
      if (this.notification.id == notificationId) {
        this.localNotification = { ...this.notification, markOpen: true };
      }
    },

    resetMarkedAsRead(notificationId) {
      if (this.notification.id == notificationId) {
        this.localNotification = { ...this.notification, markOpen: false };
      }
    },
  },
});
</script>

<style scoped lang="scss">
.mark-done-confirmations {
  margin-top: 9px;
  display: inline-block;
}
.margin-right {
  margin-right: 15px;
}
.patient-section {
  position: relative;
  z-index: 1;
  margin-bottom: 25px;
  padding: 30px 24px 35px;
  background-color: $primaryBgBlue;
  color: $primaryLightBlue;
  &__top {
    margin-bottom: 8px;
    p {
      margin: 0;
      font-size: 16px;
      line-height: 1.67;
      color: #019bdf;

      &.patient-name {
        font-size: 21px;
        margin-bottom: 8px;
      }

      &.small-text {
        font-size: 16px;
        margin-bottom: 4px;
      }

      &.bold {
        font-weight: 700;
      }
    }
  }
}

.follow-up-warning {
  background-color: #f8e71c;
  margin: 0 0px 25px 0px;
  padding: 15px 20px;

  &__content {
    span {
      color: #000000;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.5;
    }
  }
}
</style>
